import 'bootstrap';

// Utils
import match from './utils/match';
import { initReact } from './utils/initReact';

// Routes
import common from './routes/common';
import appIndex from './routes/app';
import appAccessCode from './routes/app/accessCode';
import appAccessEnrollment from './routes/app/accessEnrollment';
import registerShowRegistrationForm from './routes/register/showRegistrationForm';
import committees from './routes/committees/common';
import committeesIndex from './routes/committees/';
import committeesShow from './routes/committees/show';
import committeesMembers from './routes/committees/members';
import profilesCover from './routes/profiles/cover';
import profilesPersonal from './routes/profiles/personal';
import profilesPassword from './routes/profiles/password';
import { profilesTerms } from './routes/profiles/terms';
import profilesState from './routes/profiles/state';
import { profilesRede } from './routes/profiles/rede';
import { closedMission } from './routes/profiles/mine';
import sendPhotos from './routes/profiles/sendPhotos';
import challenge4 from './routes/profiles/challenge4';
import { profileInvites } from './routes/profiles/invites';
import { challengesIndex } from './routes/challenges/';
import { challengesSearch } from './routes/challenges/search';
import challengesCreate from './routes/challenges/create';
import challengesEdit from './routes/challenges/edit';
import challengesShow from './routes/challenges/show';
import challengesLeaderTerms from './routes/challenges/leaderTerms';
import challengesGallery from './routes/challenges/gallery';
import challengesMaterials from './routes/challenges/materials';
import { challengesMine } from './routes/challenges/mine';
import presencesIndex from './routes/presences/';
import presencesActivities from './routes/presences/activities';
import presencesDocuments from './routes/presences/documents';
import presencesGallery from './routes/presences/gallery';
import presencesSavedreport from './routes/presences/savedreport';
import { presenceBenefiteds } from './routes/presences/benefiteds';
import { presenceHours } from './routes/presences/hours';
import reportActivities from './routes/reportactivities';
import forgotpassword from './routes/forgotpassword';
import habilitiesCommon from './routes/habilities/common';
import habilitiesIndex from './routes/habilities/index';
import subscribesShow from './routes/subscribes/show';
import showResetForm from './routes/resetpassword/showResetForm';
import { ranking } from './routes/ranking';

// React
import Faq from './routes/faq';
import Materials from './routes/materials';
import Blog from './routes/blog';
import Comments from './react/components/comments';
import Feed from './routes/profiles/feed';

var APP = {
  common: {
    init() {
      common.init();
    },
  },

  app: {
    index() {
      appIndex.init();
    },

    accessCode() {
      appAccessCode.init();
    },

    accessEnrollment() {
      appAccessEnrollment.init();
    },
  },

  register: {
    showRegistrationForm() {
      registerShowRegistrationForm.init();
    },
  },

  resetpassword: {
    showResetForm() {
      showResetForm.init();
    },
  },

  committees: {
    index() {
      committeesIndex.init();
    },

    init() {
      committees.init();
    },

    show() {
      committeesShow.init();
    },

    members() {
      committeesMembers.init();
    },
  },

  profiles: {
    init() {
      closedMission();
    },

    cover() {
      profilesCover.init();
    },

    personal() {
      profilesPersonal.init();
    },

    password() {
      profilesPassword.init();
    },

    state() {
      profilesState.init();
    },

    terms() {
      profilesTerms();
    },

    rede() {
      profilesRede();
    },

    mine() {
      initReact(document.getElementById('feed'), Feed);
    },

    warcry() {
      sendPhotos.init();
    },

    challenge4() {
      challenge4.sendStory();
    },

    quiz() {},

    invites() {
      profileInvites();
    },

    photos() {
      sendPhotos.init();
    },
  },

  challenges: {
    index() {
      challengesIndex();
    },

    search() {
      challengesSearch();
    },

    create() {
      challengesCreate.init();
    },

    edit() {
      challengesEdit.init();
    },

    leaderTerms() {
      challengesLeaderTerms.init();
    },

    show() {
      challengesShow.init();

      initReact(document.getElementById('comments'), Comments);
    },

    gallery() {
      challengesGallery.init();
    },

    materials() {
      challengesMaterials.init();
    },

    mine() {
      challengesMine();
    },
  },

  presences: {
    index() {
      presencesIndex.init();
    },

    activities() {
      presencesActivities.init();
    },

    documents() {
      presencesDocuments.init();
    },

    gallery() {
      presencesGallery.init();
    },

    savedreport() {
      presencesSavedreport.init();
    },

    benefiteds() {
      presenceBenefiteds();
    },

    hours() {
      presenceHours();
    },
  },

  blogs: {
    index() {
      initReact(document.getElementById('app'), Blog);
    },
  },

  materials: {
    index() {
      initReact(document.getElementById('app'), Materials);
    },
  },

  faqs: {
    index() {
      initReact(document.getElementById('app'), Faq);
    },
  },

  forgotpassword: {
    init() {
      forgotpassword.init();
    },
  },

  habilities: {
    common() {
      habilitiesCommon.init();
    },

    index() {
      habilitiesIndex.init();
    },
  },

  subscribes: {
    show() {
      subscribesShow.init();
    },
  },

  reportactivities: {
    index() {
      reportActivities.init();
    },
  },

  ranking: {
    index() {
      ranking();
    },
  },
};

document.addEventListener('DOMContentLoaded', match.init(APP));
